module.exports = __webpack_public_path__ + "static/img/eb-example.6b60451.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customisation/eb-example.png
// module id = X8oI
// module chunks = 1